import React from 'react';

const Hero = () => {
  return (
    <section className="pt-20 md:pt-28 bg-primary">
      <div className="container mx-auto px-4 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight mb-4 md:mb-6">
              Descubra o método que transforma a forma de aprender, respeitando o ritmo e os objetivos de cada aluno
            </h1>
            <p className="text-lg md:text-xl text-white/80 mb-6 md:mb-8">
              Transformando vidas através da escrita, respeitando a individualidade de cada aluno.
            </p>
            <a
              href="#contact"
              className="inline-block px-6 md:px-8 py-3 md:py-4 bg-accent text-white rounded-full text-base md:text-lg font-semibold hover:bg-accent-dark transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              Garanta sua Vaga para 2025
            </a>
          </div>
          <div className="lg:w-1/2">
            <img
              src="https://imgur.com/SPe2Hpj.png"
              alt="Professora ensinando"
              className="rounded-lg shadow-2xl w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;